import React from "react";
import {Table} from 'antd';
import SkeletonLoader from 'components/util-components/SkeletonLoader'

const CustomTable = props => {

  const { columns,dataSource,pagination,handleTableChange,onChange,loading} = props
  const onTableChange = handleTableChange || onChange;

  if (loading) {
    return <SkeletonLoader columns={columns} loading={loading}/>
  }

  return (
    <Table
      columns={columns}
      className="customTable"
      dataSource={dataSource?.content}
      rowKey="id"
      pagination={pagination}
      onChange={onTableChange}
    />
  )
}

export default CustomTable;
